import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { ToastService } from '../../core/services/toast.service';

@Injectable()
export class authInterceptor implements HttpInterceptor {
    constructor(private authService: AuthService, private toast: ToastService) { }
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // console.log('Intercepting request to:', req.url);

        const token = sessionStorage.getItem('authToken');
        // console.log('Token found:', !!token);

        const authReq = token
            ? req.clone({ headers: req.headers.set('Authorization', `Bearer ${token}`) })
            : req;

        return next.handle(authReq).pipe(
            catchError((error: HttpErrorResponse) => {
                // console.log('Error occurred:', error);

                const is401 = error.status === 401;
                const isInvalidToken =
                    typeof error.error === 'object' &&
                    error.error?.error === 'Unauthorized or invalid token';

                if (is401 || isInvalidToken) {
                    this.authService.signOut();
                    this.toast.show('Session expired. Please log in again.', 'error');
                }

                return throwError(error);
            })
        );
    }
}
